import { 
  Elements, 
  ExpressCheckoutElement, 
  PaymentElement, 
  useElements, 
  useStripe
} from '@stripe/react-stripe-js';
import { useState } from 'react';

function CheckoutForm(props) {
  const { onClose, onSuccess} = props;
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const handleRegularPayment = async (event) => {
    event.preventDefault();
    
    if (!stripe || !elements) {
      setMessage('Chargement en cours...');
      return;
    }
  
    setLoading(true);
    setMessage('');
  
    try {
      // validations
      const { error: submitError } = await elements.submit();
      if (submitError) {
        setMessage(submitError.message);
        setLoading(false);
        return;
      }
  
      // Confirm payment intent
      const { error, paymentIntent } = await stripe.confirmPayment({
        elements,
        confirmParams: {
          return_url: window.location.origin,
        },
        redirect: 'if_required',
      });
  
      if (error) {
        // handle errors
        switch (error.type) {
          case 'card_error':
            setMessage(`Erreur de carte: ${error.message}`);
            break;
          case 'validation_error':
            setMessage(`Erreur de validation: ${error.message}`);
            break;
          case 'authentication_error':
            setMessage('Échec de l\'authentification. Veuillez réessayer.');
            break;
          default:
            setMessage('Une erreur inattendue est survenue.');
        }
      } else if (paymentIntent) {
        // Success
        switch (paymentIntent.status) {
          case 'succeeded':
            setMessage('Paiement réussi !');
            onPaymentSuccess(paymentIntent);
            break;
          case 'processing':
            setMessage('Paiement en cours de traitement...');
            break;
          case 'requires_payment_method':
            setMessage('Paiement échoué. Veuillez réessayer.');
            close()
            break;
          default:
            setMessage('Quelque chose s\'est mal passé.');
            close()
        }
      }
    } catch (err) {
      setMessage('Erreur réseau. Veuillez réessayer.');
      console.error('Erreur paiement:', err);
      close()
    } finally {
      setLoading(false);
    }
  };
  const close = () => setTimeout(() => onClose(), 2500)

  const onPaymentSuccess = () => {
    onSuccess()
  };

  const expressCheckoutOptions = {
    buttonHeight: 48,
    buttonTheme: {
      applePay: 'black',
      googlePay: 'black',
      paypal: 'gold'
    },
    layout: {
      overflow: 'never'
    }
  };

  const handleExpressCheckout = async (event) => {
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: window.location.origin,
      },
      redirect: 'if_required',
    });

    if (!error) {
      onPaymentSuccess();
    }
  };

  return (
    <form onSubmit={handleRegularPayment}>
      <ExpressCheckoutElement 
        options={expressCheckoutOptions}
        onConfirm={handleExpressCheckout}
      />
      
      <div className="divider">ou</div>
      <PaymentElement />
      
      <button 
        type="submit" 
        disabled={loading || !stripe || !elements}
        className="pay-button"
      >
        {loading ? 'Traitement...' : 'Payer maintenant'}
      </button>
      
      {message && (
        <div className={`message ${message.includes('réussi') ? 'success' : 'error'}`}>
          {message}
        </div>
      )}
    </form>
  );
}

export default CheckoutForm;